import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as repeatSentenceServices from '@iso/services/speaking/repeatSentence';

//#region CRUD
export function* getRepeatSentence() {
	yield takeLatest(actions.GET_REPEAT_SENTENCE, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(repeatSentenceServices.getRepeatSentence, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_REPEAT_SENTENCE_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.SPEAKING_LOADING_FALSE,
			});
		}
	});
}

export function* getRepeatSentenceDetail() {
	yield takeLatest(actions.GET_REPEAT_SENTENCE_DETAIL, function* ({ payload }) {
		const { id } = payload;
		try {
			var response = yield call(repeatSentenceServices.getRepeatSentenceDetail, id);
			if (response.data.success === true) {
				var data = response.data.data;
				yield put({
					type: actions.GET_REPEAT_SENTENCE_DETAIL_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({
				type: actions.SPEAKING_LOADING_FALSE,
			});
		}
	});
}

export function* createQuesRepeatSentence() {
	yield takeLatest(actions.CREATE_NEW_QUESTION_REPEAT_SENTENCE, function* ({ payload, cbSuccess, cbError }) {
		const { body } = payload;
		try {
			var response = yield call(repeatSentenceServices.createQuesRepeatSentence, body);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			}
		}
	});
}

export function* updateRepeatSentenceDetail() {
	yield takeLatest(actions.UPDATE_REPEAT_SENTENCE_DETAIL, function* ({ payload, cbSuccess, cbError }) {
		const { model } = payload;
		try {
			var response = yield call(repeatSentenceServices.updateRepeatSentenceDetail, model);
			if (response.data.success === true) {
				yield cbSuccess();
			}
			else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* deleteRepeatSentence() {
	yield takeLatest(actions.DELETE_REPEAT_SENTENCE, function* ({ payload, cbSuccess, cbError }) {
		const { id } = payload;
		try {
			var response = yield call(repeatSentenceServices.deleteRepeatSentence, id);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
			else yield cbError();
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getRepeatSentence),
		fork(getRepeatSentenceDetail),
		fork(createQuesRepeatSentence),
		fork(updateRepeatSentenceDetail),
		fork(deleteRepeatSentence),
	]);
}
